import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils';

const FaqWrapper = styled.div`
  text-align: center;
  width: 100%;
  margin-bottom: 40px;
`;

const Link = styled.a`
  color: ${colors.g04};
  font-family: Mada;
  font-size: 12px;
`;

const faqUrl = 'https://help.neevo.ai/en/collections/2215581-dialogue-collection-jobs';

export default () => (
  <FaqWrapper>
    <Link target="_blank" href={faqUrl}>
      FAQs
    </Link>
  </FaqWrapper>
);
